module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8011.f0f63033.png";